import * as LucideIcons from 'lucide-react';
import { marked } from 'marked';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Icon {
  kind: 'lucide' | string;
  value: string;
}

interface MarkdownBlockProps {
  block: {
    icon?: Icon;
    content?: string;
    markdown?: boolean;
  };
  cardContext?: any;
}

const MarkdownBlock: React.FC<MarkdownBlockProps> = ({
  block,
  cardContext,
}) => {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // Check if the clicked element is an internal link
    const target = event.target as HTMLElement;
    if (target.classList.contains('internal-link')) {
      event.preventDefault(); // Prevent default browser navigation
      const href = target.getAttribute('href');

      if (!href) return;

      // Parse the URL to check for tab parameter
      const url = new URL(href, window.location.origin);
      const tabParam = url.searchParams.get('tab');

      if (tabParam) {
        console.log('Link has tab parameter:', tabParam);
        // Just update the tab parameter in current URL, don't navigate to new path
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('tab', tabParam);
        navigate(currentUrl.pathname + currentUrl.search, { replace: true });
      } else {
        // Regular internal navigation
        navigate(href);
      }
    }
  };

  const renderIcon = (): React.ReactNode => {
    if (!block.icon) return null;

    if (block.icon.kind === 'lucide') {
      const IconComponent = (LucideIcons as any)[block.icon.value];
      return IconComponent ? <IconComponent size={24} /> : null;
    }

    return <img src={block.icon.value} alt="" />;
  };

  // TODO: Re-implement custom link renderer for internal/external link handling
  // For now, using default marked behavior to avoid breaking the app

  return (
    <div className="markdown-block">
      <div className="icon-wrapper">{renderIcon()}</div>
      <div className="content" onClick={handleClick}>
        {/* {block.markdown ? (
          <ReactMarkdown>{block.content}</ReactMarkdown>
        ) : (
          <p>{block.content}</p>
        )} */}
        <div
          className="chat-messages-wrap-content"
          dangerouslySetInnerHTML={{
            __html: block.content ? String(marked(block.content)) : '',
          }}
        />
      </div>
    </div>
  );
};

export default MarkdownBlock;
